<main class="page-container__body ">
    <div class="body_area car-details-page">
        <div class="container-fliud">
            <div class="container" *ngIf="isVisible">
                    <p style="font-size: 2.4rem;">Verification Complete!</p>
                    <p>{{msg}}</p>
                    <a href="#/login">Click Here</a> to Login
            </div>
        </div>
    </div>
</main>